import { useState, useEffect, useRef } from 'react';
/* External libs */
import { CSVLink } from "react-csv";
import jwt_decode from "jwt-decode";
/* Contexts */
import useAuth from "../../hooks/useAuth";
/* API */
import {getDeceasedList} from "../../api/pro/deceasedReq";
import DateInput from "../../components/common/input-layout/DateInput";


export default function FormFilteredDeceasedExport({setShowModal}) {
    const [ deceasedList, setDeceasedList ] = useState([]);
    const { auth } = useAuth();
    const token = auth?.token;
    const decodedToken = jwt_decode(auth.token);
    const agencyId = decodedToken.agency;
    const csvExportButton = document.getElementById("csv-export-button")
    const filterButton = document.getElementById("filter-button")
    let filteredList = [];
    const [ dataFiltered, setDataFiltered ] = useState(filteredList);
    const [ resultsCount, setResultsCount ] = useState(null);
    const today = new Date().toISOString().split('T')[0];

    const startDateRef = useRef();
    const endDateRef = useRef();

    const apiDeceasedList = async () => {
        const response = await getDeceasedList(token, agencyId, 1, 100000)
        setDeceasedList(response?.deceasedList)
    };

    useEffect(() => {
        apiDeceasedList()
    }, [ agencyId ]);

    useEffect(() => {
        if (filterButton) {
            csvExportButton.style.display = "none";
        }
    }, [ filterButton, csvExportButton ]);

    const headers = [
        { label: "Id", key : "id" },
        { label: "Nom", key : "name" },
        { label :"Prénom", key : "firstName" },
        { label :"Date de décès", key : "deathDate" },
        { label :"Date de naissance", key : "birthDate" },
    ];


    const handleFilter = (e) => {
        e.preventDefault();
        let dateTypeValue = document.querySelector('input[name="date_type"]:checked').value;
        if (dateTypeValue === "birth") {
            filteredList = deceasedList?.filter(deceased =>
                (deceased.birthDate >= startDateRef?.current?.value && deceased.birthDate <= endDateRef?.current?.value)
            )
            setDataFiltered(filteredList)
            setResultsCount(filteredList.length)
        } else if (dateTypeValue === "death") {
            filteredList = deceasedList?.filter(deceased =>
                (deceased.deathDate >= startDateRef?.current?.value && deceased.deathDate <= endDateRef?.current?.value)
            )
            setDataFiltered(filteredList)
            setResultsCount(filteredList.length)
        }
        csvExportButton.style.display = "flex";
    }

    const handleExportAll = () => {
        setDataFiltered(deceasedList)
    }

    const csvReport = {
        data : dataFiltered,
        headers : headers,
        filename : "Défunts de l'agence",
    };

    const removeLink = () => {
        csvExportButton.style.display = "none";
    }

    const handleRemoveModal = () => {
        setShowModal(false)
    }

    return (
        <div className="deceased-export-filter">
            <legend>Filtrer par date</legend>
            <div className="form-input">
                <label htmlFor="date_type">Filtrer par date de :</label>
                    <label className="radio-label">
                        <input name="date_type" type="radio" value="birth" defaultChecked/>
                        <span>Naissance</span>
                    </label>
                    <label className="radio-label">
                        <input name="date_type" type="radio" value="death"/>
                        <span>Décès</span>
                    </label>
            </div>

            <div className="date-inputs-row">
                <div className="form-input">
                    <label htmlFor="start_date">Date de début</label>
                    <DateInput ref={startDateRef} name="start_date" max="9999-12-31"/>
                </div>
                <div className="form-input">
                    <label htmlFor="end_date">Date de fin</label>
                    <DateInput ref={endDateRef} defaultValue={today} name="end_date" max="9999-12-31"/>
                </div>
            </div>
            {resultsCount !== null && (
                <div className="results-count">
                    <p>
                        <strong>{resultsCount}</strong> {resultsCount > 1 ? 'résultats trouvés' : 'résultat trouvé'}
                    </p>
                </div>
            )}
            <div className="buttons-container">
                <button id="filter-button" onClick={handleFilter} className="blue-button">
                    <i className="fa fa-filter"></i>
                    <span>Filtrer selon mes choix</span>
                </button>
                <button onClick={handleRemoveModal} className="red-button">
                    <i className="fa fa-xmark"></i>
                    <span>Annuler</span>
                </button>
                <button onClick={removeLink} id="csv-export-button" className="green-button">
                    <i className="fa fa-upload"></i>
                    <CSVLink {...csvReport}><span>Exporter les défunts filtrés</span></CSVLink>
                </button>
                { filteredList?.length < 1 && 
                    <button type="button" onClick={handleExportAll} className="green-button">
                        <i className="fa fa-upload"></i>
                        <CSVLink {...csvReport}><span>Exporter tous les défunts</span></CSVLink>
                    </button>
                }
            </div>
        </div>
    )
}